import { GeoJSONFeature } from '../../features/types';
import { LocationBox } from '@Root';
import MapboxUtilsBase from './base';

export default class MapboxUtilsFeatures extends MapboxUtilsBase {
	clustersInBox(bbox: LocationBox): GeoJSONFeature[] | undefined {
		return this._map?.queryRenderedFeatures(bbox, {
			layers: this._layerManager?.loadedClusterLayerIds,
		}) as unknown as GeoJSONFeature[];
	}

	featuresInBox(bbox: LocationBox): GeoJSONFeature[] | undefined {
		return this._map?.queryRenderedFeatures(bbox, {
			layers: this._layerManager?.selectableLayerIdsOnMap,
			filter: ['has', 'id'],
		}) as unknown as GeoJSONFeature[];
	}
}
